import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ylProductAdd, ylProductUpdate } from "@/api/financial/consumptionDetails";
import { serchSelect, serchSelectManage } from "@/mixins/index";
export default {
  mixins: [serchSelect, serchSelectManage],
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        id: "",
        game: "",
        platform: "",
        channel: "",
        ad_channel: '',
        ad_placement: '',
        yl_gid: '',
        yl_aid: '',
        yl_appid: ''
      },
      isDisplay: false,
      rules: {
        ad_channel: [{
          required: true,
          message: "请选择",
          trigger: "blur"
        }],
        ad_placement: [{
          required: true,
          message: "请请选择",
          trigger: "blur"
        }],
        special_product_id: [{
          required: true,
          message: "请选择产品",
          trigger: "blur"
        }],
        game: [{
          required: true,
          message: "请选择游戏",
          trigger: "blur"
        }],
        platform: [{
          required: true,
          message: "请选择平台",
          trigger: "blur"
        }],
        channel: [{
          required: true,
          message: "请选择渠道",
          trigger: "blur"
        }],
        yl_appid: [{
          required: true,
          message: "请输入",
          trigger: "blur"
        }]
      },
      adPlacementSingleChoice: true,
      issubstitution: false
    };
  },
  created: function created() {},
  methods: {
    open: function open(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var ProductData, ds, k;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.dialogFormVisible = true;

                if (!data) {
                  _context.next = 14;
                  break;
                }

                _context.next = 4;
                return _this.searchProductData(data);

              case 4:
                ProductData = _context.sent;
                data.product_id = ProductData.id;
                _context.next = 8;
                return _this.getAdvPlarform({
                  special_product_id: data.product_id
                });

              case 8:
                _this.searchData.ad_channel = data.ad_channel;
                _context.next = 11;
                return _this.advChannelchange(data.ad_channel);

              case 11:
                ds = {};

                for (k in _this.searchData) {
                  ds[k] = data[k] !== '' ? data[k] : '';
                }

                _this.searchData = _this.processingData(_objectSpread(_objectSpread({}, ds), {}, {
                  special_product_id: data.product_id
                }));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.dialogFormVisible = false;
      this.searchData.id = '';
      this.clearData();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var req = _this2.searchData.id ? ylProductUpdate : ylProductAdd;
          var searchData = JSON.parse(JSON.stringify(_this2.searchData));
          req(searchData).then(function (res) {
            if (res.status == 200) {
              _this2.$Message.success('操作成功');

              _this2.$emit("refreshDataList");

              _this2.resetForm("ruleForm");
            }
          });
        }
      });
    },
    clearData: function clearData() {
      this.searchData = {
        id: this.searchData.id,
        game: "",
        platform: "",
        channel: "",
        ad_channel: '',
        ad_placement: '',
        yl_gid: '',
        yl_aid: '',
        yl_appid: '',
        special_product_id: this.rawData.game_show_type == 1 ? '' : this.searchData.special_product_id
      };

      if (this.rawData.game_show_type == 1) {
        this.advchannels = [];
      }

      this.advLocation = [];
      this.$refs.ruleForm.resetFields();
    }
  }
};